import { Component } from '@angular/core';
import { NetworkService, SettingsService } from 't4core';

export type NetworkStatus = 'online' | 'offline' | 'slow' | 'restored' | 'retrying';

@Component({
  selector: 'app-network-status-banner',
  templateUrl: './network-status-banner.component.html',
  styleUrls: ['./network-status-banner.css'],
  standalone: false
})

export class NetworkStatusBannerComponent {
  status: NetworkStatus = 'online';
  public settings: SettingsService;

  constructor(private network: NetworkService, private setting: SettingsService) {
    this.settings = setting;
    if (setting.Environment != 0) {
      this.network.status$.subscribe(status => {
        this.status = status;
        if (status === 'restored') {
          setTimeout(() => this.status = 'online', 5000);
        }
      });
    }
  }

  getStatusMessage(status: NetworkStatus): string {
    switch (status) {
      case 'offline':
        return 'Oops! It looks like you are offline. Please check your internet connection...';
      case 'slow':
        return 'Your network seems slow right now. Please be patient while we try to load the content...';
      case 'restored':
        return 'Yay! Your connection has been restored. Everything should work smoothly now...';
      case 'retrying':
        return 'Please wait while we retry the connection...';
      default:
        return 'Something went wrong. Please try again later...';
    }
  }
}
